(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('NewMessageController', NewMessageController);

  /* ngInject */
  function NewMessageController($window, $state, $filter, $timeout, config, Flash, consultationService, formErrorsService, sessionService, Upload) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.messageThread = {
      visibility: 'user',
      status: 'open'
    };
    vm.messageThreadForm = {};
    vm.saveMessageThread = saveMessageThread;
    vm.saving = false;

    $window.bsCustomFileInput.init();

    function saveMessageThread(messageThread) {
      vm.clearFormErrors();

      vm.saving = true;

      let user = sessionService.getUser();
      let msgThread = {
        message_thread: {
          subject: messageThread.subject,
          status: messageThread.status,
          message_type: messageThread.message_type,
          visibility: messageThread.visibility,
          callback_requested: messageThread.callback_requested,
          callback_number: messageThread.callback_number,
          time_to_call: messageThread.time_to_call,
          timezone_to_call: messageThread.timezone_to_call,
          owner_read_flag: false,
          user_read_flag: true,
          urgent: messageThread.urgent,
          messages_attributes: [{
            body: messageThread.body,
            author_id: user.id,
            urgent: messageThread.urgent,
          }]
        }
      };

      if (messageThread.attachments != null) {
        let attachmentsUpload = Upload.upload({
          url: `${config.complianceServicesApiEndpoint}/api/message_threads`,
          method: 'POST',
          data: { message_thread: msgThread.message_thread, attachments: messageThread.attachments },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        attachmentsUpload.then(response => {
          $timeout(() => {
            createMessageSuccess(response);
          });
        }, response => {
          saveMessageFailure(response);
        });
      } else {
        consultationService(sessionService.getAuthToken()).save(msgThread, createMessageSuccess, saveMessageFailure);
      }
    }

    function createMessageSuccess(_response) {
      vm.saving = false;
      $state.go('application.compliance_services.consultation');
      Flash.create('success', 'Your consultation request was successfully submitted.');
    }

    function saveMessageFailure(response) {
      vm.saving = false;
      Flash.create('danger', 'An error occurred with your submission. Please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.messageThreadForm, response);
    }
  }
})();
